export const countryHiringGuides: Record<string, { name: string; hiringGuideUrl: string }> = {
  AR: { name: "Argentina", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/argentina" },
  AU: { name: "Australia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/australia" },
  AT: { name: "Austria", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/austria" },
  BY: { name: "Belarus", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/belarus" },
  BE: { name: "Belgium", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/belgium" },
  BA: {
    name: "Bosnia and Herzegovina",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/bosnia-and-herzegovina",
  },
  BR: { name: "Brazil", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/brazil" },
  BG: { name: "Bulgaria", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/bulgaria" },
  CA: { name: "Canada", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/canada" },
  CL: { name: "Chile", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/chile" },
  CN: { name: "China", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/china" },
  CO: { name: "Colombia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/colombia" },
  CR: { name: "Costa Rica", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/costa-rica" },
  HR: { name: "Croatia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/croatia" },
  DK: { name: "Denmark", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/denmark" },
  EG: { name: "Egypt", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/egypt" },
  EE: { name: "Estonia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/estonia" },
  FI: { name: "Finland", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/finland" },
  FR: { name: "France", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/france" },
  DE: { name: "Germany", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/germany" },
  GR: { name: "Greece", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/greece" },
  HU: { name: "Hungary", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/hungary" },
  IN: { name: "India", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/india" },
  IE: { name: "Ireland", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/ireland" },
  IL: { name: "Israel", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/israel" },
  IT: { name: "Italy", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/italy" },
  JP: { name: "Japan", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/japan" },
  KE: { name: "Kenya", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/kenya" },
  LV: { name: "Latvia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/latvia" },
  LB: { name: "Lebanon", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/lebanon" },
  LT: { name: "Lithuania", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/lithuania" },
  MY: { name: "Malaysia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/malaysia" },
  MX: { name: "Mexico", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/mexico" },
  MN: { name: "Mongolia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/mongolia" },
  NL: {
    name: "Netherlands",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/netherlands",
  },
  NZ: {
    name: "New Zealand",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/new-zealand",
  },
  NG: { name: "Nigeria", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/nigeria" },
  NO: { name: "Norway", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/norway" },
  PE: { name: "Peru", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/peru" },
  PL: { name: "Poland", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/poland" },
  PT: { name: "Portugal", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/portugal" },
  RO: { name: "Romania", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/romania" },
  RU: { name: "Russia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/russia" },
  RS: { name: "Serbia", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/serbia" },
  SG: { name: "Singapore", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/singapore" },
  ZA: {
    name: "South Africa",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/south-africa",
  },
  KR: {
    name: "South Korea",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/south-korea",
  },
  ES: { name: "Spain", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/spain" },
  SE: { name: "Sweden", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/sweden" },
  CH: {
    name: "Switzerland",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/switzerland",
  },
  TW: { name: "Taiwan", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/taiwan" },
  CZ: {
    name: "Czech Replublic",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/the-czech-republic",
  },
  PH: {
    name: "Philippines",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/the-philippines",
  },
  TR: { name: "Turkey", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/turkey" },
  UA: { name: "Ukraine", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/ukraine" },
  GB: {
    name: "United Kingdom",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/united-kingdom",
  },
  US: {
    name: "United States",
    hiringGuideUrl: "https://www.oysterhr.com/hire-employees/united-states",
  },
  UY: { name: "Uruguay", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/uruguay" },
  VN: { name: "Vietnam", hiringGuideUrl: "https://www.oysterhr.com/hire-employees/vietnam" },
}
